import { gql } from "@apollo/client";

import { IMAGE_FRAGMENT } from "./fragments";

export const CREATE_IMAGE = gql`
  ${IMAGE_FRAGMENT}
  mutation CreateImage($input: ImageCreateInput!) {
    imageCreate(input: $input) {
      image {
        ...Image
      }
      uploadUrl
    }
  }
`;
